import { Box, BoxProps } from '@chakra-ui/react';

const Span = (props: BoxProps) => {
  const { children } = props;

  return (
    <Box as="span" {...props}>
      {children}
    </Box>
  );
};

export { Span };
